define('utils/uri_helper',['underscore'], function(_){

  var buildString = function(ns, val){
    var q = [];
    if (_.isObject(val)) {
      for (var k in val) {
        if (val.hasOwnProperty(k)) {
          q.push(buildString(ns + '[' + k + ']', val[k]));
        }
      }
    }
    else {
      q.push(ns + '=' + encodeURIComponent(val));
    }
    return q.join('&');
  };

  var buildQuery = function(params){
    if (_.isString(params)){return params;}
    var q = [];
    for (var key in params) {
        if (_.has(params, key)) {
          q.push(buildString(key, params[key]));
        }
    }
    return q.join('&');
  };

  var appendToUrl = function(url, params){
    var q = buildQuery(params);
    if (q) {
      return url +(url.indexOf('?')>-1 ? '&' : '?')+ q
    }
    else {return url; }
  };

  return {
    buildQuery: buildQuery,
    appendToUrl: appendToUrl
  }
});

